import { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { ref, onValue } from 'firebase/database';
import { auth, db } from '../firebase';
import { ADMIN_EMAIL } from '../utils/constants';

export const useAuth = () => {
  // Seed initial state from sessionStorage so ProtectedRoute never flashes /login
  const cached = sessionStorage.getItem('pkx_role');
  const [user, setUser] = useState(() => auth.currentUser || null);
  const [role, setRole] = useState(cached || null);
  // If we already have a cached user+role, skip the loading spinner
  const [loading, setLoading] = useState(!auth.currentUser || !cached);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      if (!u) {
        setUser(null);
        setRole(null);
        setLoading(false);
        sessionStorage.removeItem('pkx_role');
        return;
      }
      setUser(u);
      if (u.email === ADMIN_EMAIL) {
        setRole('admin');
        setLoading(false);
        sessionStorage.setItem('pkx_role', 'admin');
      } else {
        const driverRef = ref(db, `drivers/${u.uid}`);
        onValue(driverRef, (snap) => {
          const r = snap.exists() ? 'driver' : 'unknown';
          setRole(r);
          setLoading(false);
          sessionStorage.setItem('pkx_role', r);
        }, { onlyOnce: true });
      }
    });
    return () => unsub();
  }, []);

  return { user, role, loading, isAdmin: role === 'admin', isDriver: role === 'driver' };
};
